import { fetchEndpoint } from "../network";
import { encryptPassword } from "../../util/crypto";

export default {
  // 登录
  login(params) {
    params.noShowLoading = true;
    // 加密密码
    if (params.password) {
      params.password = encryptPassword(params.password);
    }
    return fetchEndpoint("/create-platform/login", "POST", params);
  },

  // 发送验证码
  sendMsg(params) {
    return fetchEndpoint(
      "/create-platform/user-center/sendMsg",
      "POST",
      params
    );
  },

  // 二次验证
  // verify(params) {
  //   return fetchEndpoint("/create-platform/secondaryLogin", "POST", params);
  // },
  verify(params) {
    return fetchEndpoint(
      "/create-platform/admin/secondaryLogin",
      "POST",
      params
    );
  },

  // 获取用户信息
  userInfo(params) {
    params.noShowLoading = true;
    return fetchEndpoint("/create-platform/getUser", "POST", params);
  },

  // 获取智能封面
  covers(params) {
    return fetchEndpoint("/create-platform/content/cover", "POST", params);
  },

  // 获取用户等级
  level(params) {
    return fetchEndpoint("/create-platform/user/level/get", "GET", params);
  },
  // 权限
  power(params) {
    return fetchEndpoint("/create-platform/admin/user-menu", "GET", params);
  },
  // power(params) {
  //   return fetchEndpoint("/create-platform/admin/menu", "GET", params);
  // },

  getRelationMedia(params) {
    return fetchEndpoint(
      "/create-platform/mediaAccount/checkoutList",
      "get",
      params
    );
  },

  checkAccount(params) {
    return fetchEndpoint(
      "/create-platform/mediaAccount/checkout",
      "get",
      params
    );
  },

  adminUpdate(params) {
    // 加密新密码字段（如果存在）
    if (params.newPassword) {
      params.newPassword = encryptPassword(params.newPassword);
    }
    return fetchEndpoint("/create-platform/admin/update", "POST", params);
  },

  // 获取系统配置
  setting(params) {
    return fetchEndpoint("/create-platform/setting/get", "GET", params);
  },
};
